// @flow

import React, { Component } from 'react';

import Routes           from './routes';
import FetchUser        from 'components/session/fetchUser';
import Flash            from 'components/common/flash/flash';
import $                from 'jquery';
import './app.css';

// jQuery
global.jQuery = $; // We need both, uppercase Q and
global.jquery = $; // lowercase q
global.$      = $;
window.jQuery = $;
window.jquery = $;
window.$      = $;
require('bootstrap');
require('assets/js/main.js');

class App extends Component {

  componentDidCatch(error: Object, errorInfo: any) {
    console.error(error, errorInfo.componentStack);
  }

  render() {
    return (
      <div className="app">
        <FetchUser>
          <Routes />
        </FetchUser>
        <Flash />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/app.js